import React, { createContext, useContext, ReactNode } from 'react';
import { SharedValue, useSharedValue } from 'react-native-reanimated';

interface HeaderContextType {
  headerTranslateY: SharedValue<number>;
}

const HeaderContext = createContext<HeaderContextType | null>(null);

export function HeaderProvider({ children }: { children: ReactNode }) {
  const headerTranslateY = useSharedValue(0);

  return (
    <HeaderContext.Provider value={{ headerTranslateY }}>
      {children}
    </HeaderContext.Provider>
  );
}

export function useHeaderContext() {
  const context = useContext(HeaderContext);
  if (!context) {
    throw new Error('useHeaderContext must be used within a HeaderProvider');
  }
  return context;
}
